// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__-TvzD","messages":"Chat_messages__QGgBt","dateDivider":"Chat_dateDivider__p5UPo"};